<template>
   <a-select :disabled="disabled" :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners"  :placeholder="placeholder?placeholder:$t('baseVO.selectPlaceholder')">
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,index) in companyInfos" :disabled="disabledIds.length > 0 && disabledIds.indexOf(item.id) > -1" :key="index" :value="item.id">{{expensed==true?item.mainBody=='~'?item.name:item.mainBody:item.name}}</a-select-option>
   </a-select>
</template>

<script>
  import DepApi from '@/api/sys/organization'
  import { mapState } from 'vuex'
  export default {
    name: 'ptCompanySelect',
    props:{
      expensed:{
        type:Boolean,
        default:false,
      },
      disabled:{
        type:Boolean,
        default:false,
      },
      placeholder:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledIds:{
        type:Array,
        default:()=>{return []},
      },
      //是否设置默认值第一个
      isFirst:{
        type:Boolean,
        default: false,
      },
      selectAll:{
        type:Boolean,
        default:false,
      },
      addAll:{
        type:Boolean,
        default:false,
      },
    },
    computed:{
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    data() {
      return {
        input:this.value,
        companyInfos:[],
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
      input(val){
        this.$emit('input',val)
      }
    },
    mounted(){
      this.initData()
    },
    methods:{
      initData(){
        console.log("两次变更==========+1")
        DepApi.selectCompanyInfo().then(res=>{
          if(res.code == 1){
            if(this.expensed){
              this.companyInfos = res.data;
            }else{
              this.companyInfos = res.data.filter(o=>o.id != '6da7fb7980090688' && o.id != '6450d5589df1f8b7')
            }
            if(this.addAll){
              this.companyInfos.unshift({id:'a5ccfb0d7b540c6e',name:'全部'})
            }
            if(this.isFirst && !this.value){
              if(this.expensed){
                if(this.userInfo.employeeDO.accountid == '9e6ce2968ce364b2'){
                  let companyInfo = this.companyInfos.find(o=>o.id == "6450d5589df1f8b7" )
                  this.input = companyInfo.id;
                  this.$emit('input',this.input)
                  this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.value));
                  this.$emit('change-value',this.input,this.companyInfos.find(o=>o.id == this.value));
                }else if(this.userInfo.employeeDO.depId == "6f5f2e773e18c8de"){
                  let companyInfo = this.companyInfos.find(o=>o.id == "6da7fb7980090688" )
                  this.input = companyInfo.id;
                  this.$emit('input',this.input)
                  this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.value));
                  this.$emit('change-value',this.input,this.companyInfos.find(o=>o.id == this.value));
                }else{
                  let companyInfo = this.companyInfos.find(o=>o.id == this.userInfo.employeeDO.companyId )
                  this.input = companyInfo.id;
                  this.$emit('input',this.input)
                  this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.value));
                  this.$emit('change-value',this.input,this.companyInfos.find(o=>o.id == this.value));
                }
              }else{
                this.input = this.userInfo.employeeDO.companyId
                this.$emit('input',this.input)
                this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.value));
                this.$emit('change-value',this.input,this.companyInfos.find(o=>o.id == this.value));
              }

            }
            if(this.selectAll && !this.value){
              let arr = [];
              res.data.forEach(data=>{
                arr.push(data.id)
              })
              this.input = arr;
              this.$emit('input',this.input)
              this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.value));
              this.$emit('change-value',this.input,this.companyInfos.find(o=>o.id == this.value));

            }
          }
        })
      },
      changeValue(value){
        console.log("两次变更==========")
        this.$emit('input',value)
        this.$emit('change',value,this.companyInfos.find(o=>o.id == this.value))
        this.$emit('change-value',value,this.companyInfos.find(o=>o.id == this.value))
      }
    }
  }
</script>

<style scoped lang="less">

</style>